export const SKELETON_PROPS = {
  width: 150,
};
